module.exports = __webpack_public_path__ + "img/Ramadan2AR.99bae87a.png";